export const setUndockConversation = (payload) => {
  return {
    type: 'SET_UNDOCK_CONVERSATION',
    payload: payload,
  }
}
export const setUndockConversations = (payload) => {
  return {
    type: 'SET_UNDOCK_CONVERSATIONS',
    payload: payload,
  }
}
export const setUndockActiveConversation = (payload) => {
  return {
    type: 'SET_UNDOCK_ACTIVE_CONVERSATION',
    payload: payload,
  }
}
export const setUndockData = (payload) => {
  return {
    type: 'SET_UNDOCK_DATA',
    payload: payload,
  }
}
export const setUndockTreeOfKnowledge = (payload) => {
  return {
    type: 'SET_UNDOCK_TREEOFKNOWLEDGE',
    payload: payload,
  }
}
export const deleteUndock = (chatId) => {
  return {
    type: 'DELETE_UNDOCK',
    payload: chatId,
  }
}
